// Bound retained templates; concurrent instances share a single request and parse.
const templates = new Map();
const pending = new Map();
const MAX_TEMPLATES = 128;

export async function conditionIcon(url) {
  const key = new URL(url, window.location.origin);
  if (key.origin !== window.location.origin) throw new Error('Condition icons must be same-origin');
  const href = key.href;
  if (templates.has(href)) {
    const template = templates.get(href);
    templates.delete(href);
    templates.set(href, template);
    return template.cloneNode(true);
  }
  if (!pending.has(href)) {
    const request = load(href).then(template => {
      templates.set(href, template);
      if (templates.size > MAX_TEMPLATES) templates.delete(templates.keys().next().value);
      return template;
    }).finally(() => pending.delete(href));
    pending.set(href, request);
  }
  return (await pending.get(href)).cloneNode(true);
}

async function load(url) {
  const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'image/svg+xml' } });
  if (!response.ok || response.redirected || response.headers.get('content-type')?.split(';')[0] !== 'image/svg+xml') {
    throw new Error('Condition icon unavailable');
  }
  // Only the authorized endpoint's saved, sanitized SVG is parsed here.
  const document = new DOMParser().parseFromString(await response.text(), 'image/svg+xml');
  if (document.documentElement.localName !== 'svg' || document.querySelector('parsererror')) {
    throw new Error('Invalid condition icon');
  }
  return document.documentElement;
}
